import { makeAutoObservable } from 'mobx'

class TopBarStore {
  constructor () {
    this.reset()
    this.logoUrl = ''
    this.hideLogo = false

    makeAutoObservable(this)
  }

  reset () {
    this.actionIcon = null
    this.title = null
    this.authAction = null
    this.navigation = null
    this.alternativeBackground = false
  }

  setActionIcon (actionIcon) {
    this.actionIcon = actionIcon
  }

  removeActionIcon () {
    this.actionIcon = null
  }

  setTitle (title) {
    this.title = title
  }

  setAuthAction (authAction) {
    this.authAction = authAction
  }

  setNavigation (navigation) {
    this.navigation = navigation
  }

  setLogoUrl (logoUrl) {
    this.logoUrl = logoUrl
  }

  setAlternativeBackground (val) {
    this.alternativeBackground = val
  }

  setHideLogo (val) {
    this.hideLogo = val
  }
}

const topBarStore = new TopBarStore()

export { topBarStore }
